import React from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";

const LoginPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "login_desktop" */ "~/components/desktop/pages/Login"
    ),
  loading: LoadableLoading,
  delay: 500
});

const LoginPage = props => {
  return <LoginPageDesktop {...props} />;
};

const mapStateToProps = state => ({
  device: state.global.device.type
});

export default connect(mapStateToProps)(LoginPage);
